import { Shield, HeartHandshake, Award, Lock, Users, Zap } from "lucide-react";

const FEATURES = [
  { icon: HeartHandshake, title: "Compassion first", desc: "An accident often happens on the worst day of someone's life. Our role starts with listening — never with pressure." },
  { icon: Award, title: "Vetted Indiana attorneys", desc: "Our network is curated. Each attorney is licensed in Indiana with proven results in their accident specialty." },
  { icon: Zap, title: "Lightning-fast response", desc: "Most calls connect within minutes — not hours or days. Time matters in injury claims." },
  { icon: Lock, title: "100% confidential", desc: "Your information is never sold. Communications are protected by attorney–client privilege once you're connected." },
  { icon: Shield, title: "No fees unless you win", desc: "Every attorney in our network works on contingency. You pay nothing upfront. Nothing if they don't win." },
  { icon: Users, title: "Local Indiana knowledge", desc: "From Cuyahoga County courts to the I-75 trucking corridor, our attorneys know Indiana inside and out." },
];

export default function TrustSection() {
  return (
    <section className="section bg-bone" data-testid="trust-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="overline mb-3">Why Indiana Accident Aid</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-forest tracking-tight mb-4 text-balance">
            Built for Indianaans, by people who understand.
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
            We're not a law firm. We're a free service that helps accident victims navigate a confusing
            process and connects them with the right attorney for their situation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {FEATURES.map((f, idx) => (
            <div key={idx} className="card-elevated p-6 md:p-7" data-testid={`trust-feature-${idx}`}>
              <div className="w-11 h-11 rounded-xl bg-terracotta/10 text-terracotta grid place-items-center mb-4">
                <f.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-lg md:text-xl text-forest mb-2 leading-tight">
                {f.title}
              </h3>
              <p className="text-sm md:text-base text-charcoal-soft leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
